export default __webpack_public_path__ + "static/media/04_platin 1.a3d11c95.svg";